import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "frequently-asked-questions---adobe-mobile-library-v4-end-of-support"
    }}>{`Frequently asked questions - Adobe Mobile Library (v4) end-of-support`}</h1>
    <h2 {...{
      "id": "why-is-the-support-for-adobe-mobile-library-v4-ending"
    }}>{`Why is the support for Adobe Mobile Library (v4) ending?`}</h2>
    <p>{`The version 4 SDKs were first released in September 2013 to support mobile app implementations for Adobe Analytics (including Mobile Services), Adobe Audience Manager, Adobe Target, and Adobe Campaign. These performant, well-tested SDKs provided rich functionality and are used in well over 18,000 apps across app stores.`}</p>
    <p>{`Spurred by customer feedback for more control, performance, and functionality over the years; and to support future product enhancements, we released the re-architected Adobe Experience Platform Mobile SDKs in September 2018. The new Experience Platform Mobile SDKs replaces the version 4 SDKs and provide support for new features such as flexible configuration through the Data Collection UI, modular Adobe and partner extensions.`}</p>
    <p>{`Solutions such as `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/places/using/home.html"
      }}>{`Places Service`}</a>{` and `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/assurance/home.html"
      }}>{`Adobe Experience Platform Assurance`}</a>{` are exclusively available on Experience Platform Mobile SDKs.`}</p>
    <h2 {...{
      "id": "where-do-i-learn-more-about-upgradingmigrating-to-the-experience-platform-mobile-sdks"
    }}>{`Where do I learn more about upgrading/migrating to the Experience Platform Mobile SDKs?`}</h2>
    <p>{`To upgrade to the Experience Platform SDKs, see `}<a parentName="p" {...{
        "href": ".."
      }}>{`Upgrade to the Experience Platform SDKs`}</a>{`.`}</p>
    <h2 {...{
      "id": "will-mobile-services-functionality-still-work"
    }}>{`Will Mobile Services functionality still work?`}</h2>
    <p>{`No. Adobe Mobile Service's end-of-life date is `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/mobile-services/using/eol.html"
      }}>{`December 31, 2022`}</a>{`.`}</p>
    <h2 {...{
      "id": "can-i-still-download-and-use-the-version-4-sdks"
    }}>{`Can I still download and use the version 4 SDKs?`}</h2>
    <p>{`You can continue to use the version 4 SDKs after the end-of-support dates. However, as mentioned in the `}<a parentName="p" {...{
        "href": "./index.md#end-of-support-considerations"
      }}>{`end-of-support considerations section`}</a>{`, no support will be provided.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`SDK downloads through GitHub and other locations will be available through `}<strong parentName="p">{`August 31, 2021`}</strong>{`.`}</p>
    <h2 {...{
      "id": "who-do-i-contact-for-more-information-the-end-of-support-for-version-4-sdks"
    }}>{`Who do I contact for more information the end-of-support for Version 4 SDKs?`}</h2>
    <p>{`To discuss your specific situation and receive advice on the best next steps, contact `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/?support-solution=General#support"
      }}>{`Adobe Customer Support`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      